// import React, { useState, useEffect } from 'react';
// import {
//   Box,
//   Button,
//   Card,
//   CardContent,
//   Typography,
//   Chip,
//   IconButton,
//   Dialog,
//   DialogTitle,
//   DialogContent,
//   DialogActions,
//   TextField,
//   Alert,
//   Grid,
//   FormControl,
//   FormControlLabel,
//   Checkbox,
//   InputLabel,
//   Select,
//   MenuItem,
//   InputAdornment,
// } from '@mui/material';
// import { DataGrid } from '@mui/x-data-grid';
// import { Add, Edit, Delete, Build, CloudUpload } from '@mui/icons-material';
// import { Formik, Form } from 'formik';
// import * as Yup from 'yup';
// import apiService from '../services/apiService';
// import config from '../config/config';

// const ServicesPage = () => {
//   const [services, setServices] = useState([]);
//   const [loading, setLoading] = useState(true);
//   const [error, setError] = useState('');
//   const [openDialog, setOpenDialog] = useState(false);
//   const [editMode, setEditMode] = useState(false);
//   const [selectedService, setSelectedService] = useState(null);
//   const [regions, setRegions] = useState([]);  
//   const [serviceImagePreview, setServiceImagePreview] = useState(null);
//   const [markerImagePreview, setMarkerImagePreview] = useState(null);

//   useEffect(() => {
//     fetchServices();
//     fetchRegions();
//   }, []);

//   const fetchServices = async () => {
//     try {
//       setLoading(true);
//       setError('');
//       const response = await apiService.getServices();

//       if (response.success) {
//         setServices(response.data);
//       } else {
//         setError(response.message || 'Failed to load services');
//       }
//     } catch (err) {
//       console.error('Services error:', err);
//       setError('Failed to load services');
//     } finally {
//       setLoading(false);
//     }
//   };

//   const fetchRegions = async () => {
//     try {
//       const response = await apiService.getRegions();
//       if (response.success) {
//         setRegions(response.data);
//       }
//     } catch (err) {
//       console.error('Regions error:', err);
//     }
//   };

//   const handleAdd = () => {
//     setEditMode(false);
//     setSelectedService(null);
//     setServiceImagePreview(null);
//     setMarkerImagePreview(null);
//     setOpenDialog(true);
//   };

//   const handleEdit = (service) => {
//     console.log('Editing service:', service);
//     setEditMode(true);
//     setSelectedService(service);
//     // Construct full image URLs - image paths already include 'uploads/' prefix
//     // So we use SOCKET_URL (base server URL) instead of UPLOADS_BASE_URL
//     const baseUrl = config.SOCKET_URL; // http://IP:5000
//     const serviceImageUrl = service.service_image ? `${baseUrl}/${service.service_image}` : null;
//     const markerImageUrl = service.marker_image ? `${baseUrl}/${service.marker_image}` : null;
//     console.log('Service image URL:', serviceImageUrl);
//     console.log('Marker image URL:', markerImageUrl);
//     setServiceImagePreview(serviceImageUrl);
//     setMarkerImagePreview(markerImageUrl);
//     setOpenDialog(true);
//   };

//   const handleDelete = async (id) => {
//     if (!window.confirm('Are you sure you want to delete this service?')) {
//       return;
//     }

//     try {
//       const response = await apiService.deleteService(id);

//       if (response.success) {
//         alert('Service deleted successfully');
//         fetchServices();
//       } else {
//         alert(response.message || 'Failed to delete service');
//       }
//     } catch (err) {
//       alert('Failed to delete service');
//     }
//   };

//   const handleSubmit = async (values, { setSubmitting }) => {
//     try {
//       // Create FormData for file uploads
//       const formData = new FormData();
//       formData.append('name', values.name);
//       formData.append('description', values.description);
//       formData.append('region_id', values.region_id);
//       formData.append('capacity', values.capacity);
//       formData.append('base_fare', values.base_fare);
//       formData.append('pickup_km', values.pickup_km);
//       formData.append('pickup_fare', values.pickup_fare);
//       formData.append('minimum_distance', values.minimum_distance);
//       formData.append('waiting_time_limit', values.waiting_time_limit);
//       formData.append('per_distance', values.per_distance);
//       formData.append('night_fare', values.night_fare);
//       formData.append('payment_method', values.payment_method);
//       formData.append('status', values.status);
//       formData.append('isActive', values.isActive);
//       formData.append('toll_applicable', values.toll_applicable ? 'true' : 'false');

//       if (values.service_image && values.service_image instanceof File) {
//         formData.append('service_image', values.service_image);
//       }

//       if (values.marker_image && values.marker_image instanceof File) {
//         formData.append('marker_image', values.marker_image);
//       }

//       let response;
//       if (editMode) {
//         response = await apiService.updateService(selectedService.id, formData);
//       } else {
//         response = await apiService.addService(formData);
//       }

//       if (response.success) {
//         alert(`Service ${editMode ? 'updated' : 'created'} successfully`);
//         setOpenDialog(false);
//         setServiceImagePreview(null);
//         setMarkerImagePreview(null);
//         fetchServices();
//       } else {
//         alert(response.message || 'Operation failed');
//       }
//     } catch (err) {
//       console.error('Service operation error:', err);
//       alert('Operation failed');
//     } finally {
//       setSubmitting(false);
//     }
//   };

//   const validationSchema = Yup.object({
//     name: Yup.string().required('Service name is required'),
//     description: Yup.string().required('Description is required'),
//     region_id: Yup.string().required('Region is required'),
//     capacity: Yup.number()
//       .required('Capacity is required')
//       .positive('Capacity must be positive')
//       .integer('Capacity must be an integer'),
//     base_fare: Yup.number()
//       .required('Base Fare Km is required')
//       .min(0, 'Base Fare Km cannot be negative'),
//     pickup_km: Yup.number()
//       .required('Minimum Pickup is required')
//       .min(0, 'Minimum Pickup cannot be negative'),
//     pickup_fare: Yup.number()
//       .required('Pickup fare is required')
//       .min(0, 'Pickup fare cannot be negative'),
//     minimum_distance: Yup.number()
//       .required('Minimum distance is required')
//       .min(0, 'Minimum distance cannot be negative'),
//     waiting_time_limit: Yup.number()
//       .required('Waiting time limit is required')
//       .min(0, 'Waiting time limit cannot be negative'),
//     per_distance: Yup.number()
//       .required('Minimum Fare is required')
//       .min(0, 'Minimum Fare cannot be negative'),
//     night_fare: Yup.number()
//       .required('Night fare is required')
//       .min(0, 'Night fare cannot be negative')
//       .max(100, 'Night fare cannot exceed 100%'),
//     payment_method: Yup.string().required('Payment method is required'),
//     status: Yup.string().required('Status is required'),
//   });

//   const columns = [
//     {
//       field: 'name',
//       headerName: 'Service Name',
//       width: 200,
//       renderCell: (params) => (
//         <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
//           <Build color="primary" />
//           <Typography variant="body2" fontWeight={600}>
//             {params.row.name}
//           </Typography>
//         </Box>
//       ),
//     },
//     {
//       field: 'description',
//       headerName: 'Description',
//       width: 250,
//     },
//     {
//       field: 'per_distance',
//       headerName: 'Minimum Fare',
//       width: 130,
//       renderCell: (params) => (
//         <Typography variant="body2">
//           ₹{params.row.per_distance || 0}
//         </Typography>
//       ),
//     },
//     {
//       field: 'base_fare',
//       headerName: 'Base Fare Km',
//       width: 130,
//       renderCell: (params) => (
//         <Typography variant="body2">
//           ₹{params.row.base_fare || 0}/km
//         </Typography>
//       ),
//     },
//     {
//       field: 'capacity',
//       headerName: 'Capacity',
//       width: 100,
//       renderCell: (params) => (
//         <Typography variant="body2">
//           {params.row.capacity || 0} passengers
//         </Typography>
//       ),
//     },
//     {
//       field: 'status',
//       headerName: 'Status',
//       width: 120,
//       renderCell: (params) =>
//         params.row.status === 'active' ? (
//           <Chip label="Active" color="success" size="small" />
//         ) : (
//           <Chip label="Inactive" color="default" size="small" />
//         ),
//     },
//     {
//       field: 'actions',
//       headerName: 'Actions',
//       width: 150,
//       sortable: false,
//       renderCell: (params) => (
//         <Box>
//           <IconButton size="small" onClick={() => handleEdit(params.row)}>
//             <Edit fontSize="small" />
//           </IconButton>
//           <IconButton size="small" color="error" onClick={() => handleDelete(params.row.id)}>
//             <Delete fontSize="small" />
//           </IconButton>
//         </Box>
//       ),
//     },
//   ];

//   return (
//     <Box>
//       <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 3 }}>
//         <Box>
//           <Typography variant="h4" fontWeight="bold" gutterBottom>
//             Services
//           </Typography>
//           <Typography variant="body2" color="text.secondary">
//             Manage ride services
//           </Typography>
//         </Box>
//         <Button variant="contained" startIcon={<Add />} onClick={handleAdd}>
//           Add Service
//         </Button>
//       </Box>

//       {error && (
//         <Alert severity="error" sx={{ mb: 3 }}>
//           {error}
//         </Alert>
//       )}

//       <Card>
//         <CardContent>
//           <DataGrid
//             rows={services}
//             columns={columns}
//             pageSize={10}
//             rowsPerPageOptions={[10, 25, 50]}
//             disableSelectionOnClick
//             autoHeight
//             loading={loading}
//             sx={{
//               '& .MuiDataGrid-cell:focus': {
//                 outline: 'none',
//               },
//             }}
//           />
//         </CardContent>
//       </Card>

//       {/* Add/Edit Service Dialog */}
//       <Dialog open={openDialog} onClose={() => setOpenDialog(false)} maxWidth="md" fullWidth>
//         <DialogTitle>{editMode ? 'Edit' : 'Add'} Service</DialogTitle>
//         <Formik
//           initialValues={{
//             name: selectedService?.name || '',
//             description: selectedService?.description || '',
//             region_id: selectedService?.region_id || '',
//             capacity: selectedService?.capacity || '',
//             base_fare: selectedService?.base_fare || '',
//             pickup_km: selectedService?.pickup_km || '',
//             pickup_fare: selectedService?.pickup_fare || '',
//             minimum_distance: selectedService?.minimum_distance || '',
//             waiting_time_limit: selectedService?.waiting_time_limit || '',
//             per_distance: selectedService?.per_distance || '',
//             night_fare: selectedService?.night_fare || '',
//             payment_method: selectedService?.payment_method || 'cash',
//             status: selectedService?.status || 'active',
//             isActive: selectedService?.isActive ?? true,
//             toll_applicable: selectedService?.toll_applicable ?? true,
//           }}
//           validationSchema={validationSchema}
//           onSubmit={handleSubmit}
//         >
//           {({ values, errors, touched, handleChange, handleBlur, isSubmitting, setFieldValue }) => (
//             <Form>
//               <DialogContent>
//                 <Grid container spacing={3}>
//                   <Grid item xs={12} sm={6}>
//                     <TextField
//                       fullWidth
//                       name="name"
//                       label="Service Name"
//                       value={values.name}
//                       onChange={handleChange}
//                       onBlur={handleBlur}
//                       error={touched.name && Boolean(errors.name)}
//                       helperText={touched.name && errors.name}
//                       placeholder="e.g., Regular Ride"
//                     />
//                   </Grid>

//                   <Grid item xs={12} sm={6}>
//                     <FormControl fullWidth error={touched.region_id && Boolean(errors.region_id)}>
//                       <InputLabel>Region</InputLabel>
//                       <Select
//                         name="region_id"
//                         value={values.region_id}
//                         onChange={handleChange}
//                         onBlur={handleBlur}
//                         label="Region"
//                       >
//                         {regions.map((region) => (
//                           <MenuItem key={region.id} value={region.id}>
//                             {region.name}
//                           </MenuItem>
//                         ))}
//                       </Select>
//                       {touched.region_id && errors.region_id && (
//                         <Typography variant="caption" color="error" sx={{ mt: 0.5, ml: 1.5 }}>
//                           {errors.region_id}
//                         </Typography>
//                       )}
//                     </FormControl>
//                   </Grid>

//                   <Grid item xs={12}>
//                     <TextField
//                       fullWidth
//                       name="description"
//                       label="Description"
//                       value={values.description}
//                       onChange={handleChange}
//                       onBlur={handleBlur}
//                       error={touched.description && Boolean(errors.description)}
//                       helperText={touched.description && errors.description}
//                       multiline
//                       rows={3}
//                       placeholder="Describe the service..."
//                     />
//                   </Grid>

//                   <Grid item xs={12} sm={6}>
//                     <TextField
//                       fullWidth
//                       name="capacity"
//                       label="Capacity"
//                       type="number"
//                       value={values.capacity}
//                       onChange={handleChange}
//                       onBlur={handleBlur}
//                       error={touched.capacity && Boolean(errors.capacity)}
//                       helperText={touched.capacity && errors.capacity}
//                       placeholder="e.g., 4"
//                       InputProps={{
//                         endAdornment: <InputAdornment position="end">passengers</InputAdornment>,
//                       }}
//                     />
//                   </Grid>

//                   <Grid item xs={12} sm={6}>
//                     <TextField
//                       fullWidth
//                       name="per_distance"
//                       label="Minimum Fare"
//                       type="number"
//                       value={values.per_distance}
//                       onChange={handleChange}
//                       onBlur={handleBlur}
//                       error={touched.per_distance && Boolean(errors.per_distance)}
//                       helperText={touched.per_distance && errors.per_distance || "Minimum total ride fare amount"}
//                       placeholder="e.g., 50"
//                       InputProps={{
//                         startAdornment: <InputAdornment position="start">₹</InputAdornment>,
//                       }}
//                     />
//                   </Grid>

//                   <Grid item xs={12} sm={6}>
//                     <TextField
//                       fullWidth
//                       name="base_fare"
//                       label="Base Fare Km"
//                       type="number"
//                       value={values.base_fare}
//                       onChange={handleChange}
//                       onBlur={handleBlur}
//                       error={touched.base_fare && Boolean(errors.base_fare)}
//                       helperText={touched.base_fare && errors.base_fare || "Per-km rate for extra distance beyond minimum distance"}
//                       placeholder="e.g., 14"
//                       InputProps={{
//                         startAdornment: <InputAdornment position="start">₹</InputAdornment>,
//                         endAdornment: <InputAdornment position="end">/km</InputAdornment>,
//                       }}
//                     />
//                   </Grid>

//                   <Grid item xs={12} sm={6}>
//                     <TextField
//                       fullWidth
//                       name="pickup_km"
//                       label="Minimum Pickup"
//                       type="number"
//                       value={values.pickup_km}
//                       onChange={handleChange}
//                       onBlur={handleBlur}
//                       error={touched.pickup_km && Boolean(errors.pickup_km)}
//                       helperText={touched.pickup_km && errors.pickup_km}
//                       placeholder="e.g., 2"
//                       InputProps={{
//                         endAdornment: <InputAdornment position="end">km</InputAdornment>,
//                       }}
//                     />
//                   </Grid>

//                   <Grid item xs={12} sm={6}>
//                     <TextField
//                       fullWidth
//                       name="pickup_fare"
//                       label="Pickup Fare"
//                       type="number"
//                       value={values.pickup_fare}
//                       onChange={handleChange}
//                       onBlur={handleBlur}
//                       error={touched.pickup_fare && Boolean(errors.pickup_fare)}
//                       helperText={touched.pickup_fare && errors.pickup_fare}
//                       placeholder="e.g., 30"
//                       InputProps={{
//                         startAdornment: <InputAdornment position="start">₹</InputAdornment>,
//                         endAdornment: <InputAdornment position="end">/km</InputAdornment>,
//                       }}
//                     />
//                   </Grid>

//                   <Grid item xs={12} sm={6}>
//                     <TextField
//                       fullWidth
//                       name="minimum_distance"
//                       label="Minimum Distance"
//                       type="number"
//                       value={values.minimum_distance}
//                       onChange={handleChange}
//                       onBlur={handleBlur}
//                       error={touched.minimum_distance && Boolean(errors.minimum_distance)}
//                       helperText={touched.minimum_distance && errors.minimum_distance}
//                       placeholder="e.g., 1"
//                       InputProps={{
//                         endAdornment: <InputAdornment position="end">km</InputAdornment>,
//                       }}
//                     />
//                   </Grid>

//                   <Grid item xs={12} sm={6}>
//                     <TextField
//                       fullWidth
//                       name="waiting_time_limit"
//                       label="Waiting Time Limits"
//                       type="number"
//                       value={values.waiting_time_limit}
//                       onChange={handleChange}
//                       onBlur={handleBlur}
//                       error={touched.waiting_time_limit && Boolean(errors.waiting_time_limit)}
//                       helperText={touched.waiting_time_limit && errors.waiting_time_limit}
//                       placeholder="e.g., 5"
//                       InputProps={{
//                         endAdornment: <InputAdornment position="end">minutes</InputAdornment>,
//                       }}
//                     />
//                   </Grid>


//                   <Grid item xs={12} sm={6}>
//                     <TextField
//                       fullWidth
//                       name="night_fare"
//                       label="Night Fare"
//                       type="number"
//                       value={values.night_fare}
//                       onChange={handleChange}
//                       onBlur={handleBlur}
//                       error={touched.night_fare && Boolean(errors.night_fare)}
//                       helperText={touched.night_fare && errors.night_fare}
//                       placeholder="e.g., 20"
//                       InputProps={{
//                         endAdornment: <InputAdornment position="end">%</InputAdornment>,
//                       }}
//                     />
//                   </Grid>

//                   <Grid item xs={12} sm={6}>
//                     <FormControl fullWidth error={touched.payment_method && Boolean(errors.payment_method)}>
//                       <InputLabel>Payment Method</InputLabel>
//                       <Select
//                         name="payment_method"
//                         value={values.payment_method}
//                         onChange={handleChange}
//                         onBlur={handleBlur}
//                         label="Payment Method"
//                       >
//                         <MenuItem value="cash">Cash</MenuItem>
//                         <MenuItem value="wallet">Wallet</MenuItem>
//                         <MenuItem value="both">Both</MenuItem>
//                       </Select>
//                       {touched.payment_method && errors.payment_method && (
//                         <Typography variant="caption" color="error" sx={{ mt: 0.5, ml: 1.5 }}>
//                           {errors.payment_method}
//                         </Typography>
//                       )}
//                     </FormControl>
//                   </Grid>

//                   <Grid item xs={12} sm={6}>
//                     <FormControl fullWidth error={touched.status && Boolean(errors.status)}>
//                       <InputLabel>Status</InputLabel>
//                       <Select
//                         name="status"
//                         value={values.status}
//                         onChange={handleChange}
//                         onBlur={handleBlur}
//                         label="Status"
//                       >
//                         <MenuItem value="active">Active</MenuItem>
//                         <MenuItem value="inactive">Inactive</MenuItem>
//                       </Select>
//                       {touched.status && errors.status && (
//                         <Typography variant="caption" color="error" sx={{ mt: 0.5, ml: 1.5 }}>
//                           {errors.status}
//                         </Typography>
//                       )}
//                     </FormControl>
//                   </Grid>

//                   <Grid item xs={12}>
//                     <FormControlLabel
//                       control={
//                         <Checkbox
//                           name="toll_applicable"
//                           checked={values.toll_applicable}
//                           onChange={(e) => setFieldValue('toll_applicable', e.target.checked)}
//                         />
//                       }
//                       label="Show Toll Charges Notice"
//                     />
//                     <Typography variant="caption" display="block" color="text.secondary" sx={{ ml: 4 }}>
//                       When enabled, passengers booking this service will see a toll-charges disclaimer.
//                       Disable for services that cannot use toll roads (e.g., Auto).
//                     </Typography>
//                   </Grid>

//                   <Grid item xs={12} sm={6}>
//                     <Button
//                       variant="outlined"
//                       component="label"
//                       fullWidth
//                       startIcon={<CloudUpload />}
//                       sx={{ height: '56px' }}
//                     >
//                       Upload Service Image
//                       <input
//                         type="file"
//                         hidden
//                         accept="image/*"
//                         onChange={(e) => {
//                           const file = e.target.files[0];
//                           if (file) {
//                             setFieldValue('service_image', file);
//                             setServiceImagePreview(URL.createObjectURL(file));
//                           }
//                         }}
//                       />
//                     </Button>
//                     {serviceImagePreview && (
//                       <Box sx={{ mt: 2, textAlign: 'center', p: 2, bgcolor: '#f5f5f5', borderRadius: 2 }}>
//                         <Box
//                           component="img"
//                           src={serviceImagePreview}
//                           alt="Service Preview"
//                           sx={{
//                             maxWidth: '100%',
//                             maxHeight: 150,
//                             borderRadius: 1,
//                             border: '2px solid #e0e0e0',
//                           }}
//                           onError={(e) => {
//                             console.error('Service image failed to load:', serviceImagePreview);
//                             e.target.src = 'data:image/svg+xml,%3Csvg xmlns="http://www.w3.org/2000/svg" width="100" height="100"%3E%3Crect fill="%23f0f0f0" width="100" height="100"/%3E%3Ctext x="50%25" y="50%25" text-anchor="middle" dy=".3em" fill="%23999"%3ENo Image%3C/text%3E%3C/svg%3E';
//                           }}
//                         />
//                         <Typography variant="caption" display="block" sx={{ mt: 1, color: 'text.secondary' }}>
//                           {serviceImagePreview.includes('blob:') ? 'New image selected' : 'Current image'}
//                         </Typography>
//                       </Box>
//                     )}
//                   </Grid>

//                   <Grid item xs={12} sm={6}>
//                     <Button
//                       variant="outlined"
//                       component="label"
//                       fullWidth
//                       startIcon={<CloudUpload />}
//                       sx={{ height: '56px' }}
//                     >
//                       Upload Marker Image (Top View Vehicle – 48×48 px)
//                       <input
//                         type="file"
//                         hidden
//                         accept="image/png,image/jpeg"
//                         onChange={(e) => {
//                           const file = e.target.files[0];
//                           if (file) {
//                             const img = new Image();
//                             img.onload = () => {
//                               if (img.width === 48 && img.height === 48) {
//                                 setFieldValue('marker_image', file);
//                                 setMarkerImagePreview(URL.createObjectURL(file));
//                               } else {
//                                 alert(`Invalid marker image size: ${img.width}×${img.height}px. Must be exactly 48×48 pixels.`);
//                                 e.target.value = '';
//                               }
//                             };
//                             img.src = URL.createObjectURL(file);
//                           }
//                         }}
//                       />
//                     </Button>
//                     {markerImagePreview && (
//                       <Box sx={{ mt: 2, textAlign: 'center', p: 2, bgcolor: '#f5f5f5', borderRadius: 2 }}>
//                         <Box
//                           component="img"
//                           src={markerImagePreview}
//                           alt="Marker Preview"
//                           sx={{
//                             maxWidth: '100%',
//                             maxHeight: 150,
//                             borderRadius: 1,
//                             border: '2px solid #e0e0e0',
//                           }}
//                           onError={(e) => {
//                             console.error('Marker image failed to load:', markerImagePreview);
//                             e.target.src = 'data:image/svg+xml,%3Csvg xmlns="http://www.w3.org/2000/svg" width="100" height="100"%3E%3Crect fill="%23f0f0f0" width="100" height="100"/%3E%3Ctext x="50%25" y="50%25" text-anchor="middle" dy=".3em" fill="%23999"%3ENo Image%3C/text%3E%3C/svg%3E';
//                           }}
//                         />
//                         <Typography variant="caption" display="block" sx={{ mt: 1, color: 'text.secondary' }}>
//                           {markerImagePreview.includes('blob:') ? 'New image selected' : 'Current image'}
//                         </Typography>
//                       </Box>
//                     )}
//                   </Grid>
//                 </Grid>
//               </DialogContent>
//               <DialogActions>
//                 <Button onClick={() => setOpenDialog(false)}>Cancel</Button>
//                 <Button
//                   type="submit"
//                   variant="contained"
//                   disabled={isSubmitting}
//                   sx={{
//                     bgcolor: '#FFC107',
//                     color: '#000',
//                     '&:hover': {
//                       bgcolor: '#FFD54F',
//                     },
//                   }}
//                 >
//                   {editMode ? 'Update' : 'Create'}
//                 </Button>
//               </DialogActions>
//             </Form>
//           )}
//         </Formik>
//       </Dialog>
//     </Box>
//   );
// };

// export default ServicesPage;


import React, { useState, useEffect } from 'react';
import {
  Box,
  Button,
  Card,
  CardContent,
  Typography,
  Chip,
  IconButton,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  Alert,
  Grid,
  FormControl,
  FormControlLabel,
  Checkbox,
  InputLabel,
  Select,
  MenuItem,
  InputAdornment,
  Paper,
} from '@mui/material';
import { DataGrid } from '@mui/x-data-grid';
import { Add, Edit, Delete, Build, CloudUpload, FilterList, Public, LocationOn } from '@mui/icons-material';
import { Formik, Form } from 'formik';
import * as Yup from 'yup';
import apiService from '../services/apiService';
import config from '../config/config';

const ServicesPage = () => {
  const [services, setServices] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const [openDialog, setOpenDialog] = useState(false);
  const [editMode, setEditMode] = useState(false);
  const [selectedService, setSelectedService] = useState(null);
  const [regions, setRegions] = useState([]);
  const [selectedRegion, setSelectedRegion] = useState('');
  const [serviceImagePreview, setServiceImagePreview] = useState(null);
  const [markerImagePreview, setMarkerImagePreview] = useState(null);

  useEffect(() => {
    fetchServices();
    fetchRegions();
  }, []);

  const fetchServices = async () => {
    try {
      setLoading(true);
      setError('');
      const response = await apiService.getServices();

      if (response.success) {
        setServices(response.data);
      } else {
        setError(response.message || 'Failed to load services');
      }
    } catch (err) {
      console.error('Services error:', err);
      setError('Failed to load services');
    } finally {
      setLoading(false);
    }
  };

  const fetchRegions = async () => {
    try {
      const response = await apiService.getRegions();
      if (response.success) {
        setRegions(response.data);
      }
    } catch (err) {
      console.error('Regions error:', err);
    }
  };

  const handleAdd = () => {
    setEditMode(false);
    setSelectedService(null);
    setServiceImagePreview(null);
    setMarkerImagePreview(null);
    setOpenDialog(true);
  };

  const handleEdit = (service) => {
    console.log('Editing service:', service);
    setEditMode(true);
    setSelectedService(service);
    // Construct full image URLs - image paths already include 'uploads/' prefix
    // So we use SOCKET_URL (base server URL) instead of UPLOADS_BASE_URL
    const baseUrl = config.SOCKET_URL; // http://IP:5000
    const serviceImageUrl = service.service_image ? `${baseUrl}/${service.service_image}` : null;
    const markerImageUrl = service.marker_image ? `${baseUrl}/${service.marker_image}` : null;
    console.log('Service image URL:', serviceImageUrl);
    console.log('Marker image URL:', markerImageUrl);
    setServiceImagePreview(serviceImageUrl);
    setMarkerImagePreview(markerImageUrl);
    setOpenDialog(true);
  };

  const handleDelete = async (id) => {
    if (!window.confirm('Are you sure you want to delete this service?')) {
      return;
    }

    try {
      const response = await apiService.deleteService(id);

      if (response.success) {
        alert('Service deleted successfully');
        fetchServices();
      } else {
        alert(response.message || 'Failed to delete service');
      }
    } catch (err) {
      alert('Failed to delete service');
    }
  };

  const handleSubmit = async (values, { setSubmitting }) => {
    try {
      // Create FormData for file uploads
      const formData = new FormData();
      formData.append('name', values.name);
      formData.append('description', values.description);        
      formData.append('region_id', values.region_id);
      formData.append('capacity', values.capacity);
      formData.append('base_fare', values.base_fare);
      formData.append('pickup_km', values.pickup_km);
      formData.append('pickup_fare', values.pickup_fare);
      formData.append('minimum_distance', values.minimum_distance);
      formData.append('waiting_time_limit', values.waiting_time_limit);
      formData.append('per_distance', values.per_distance);
      formData.append('night_fare', values.night_fare);
      formData.append('payment_method', values.payment_method);
      formData.append('status', values.status);
      formData.append('isActive', values.isActive);
      formData.append('toll_applicable', values.toll_applicable ? 'true' : 'false');
      formData.append('is_local', values.is_local ? 'true' : 'false');

      if (values.service_image && values.service_image instanceof File) {
        formData.append('service_image', values.service_image);
      }

      if (values.marker_image && values.marker_image instanceof File) {
        formData.append('marker_image', values.marker_image);
      }

      let response;
      if (editMode) {
        response = await apiService.updateService(selectedService.id, formData);
      } else {
        response = await apiService.addService(formData);
      }

      if (response.success) {
        alert(`Service ${editMode ? 'updated' : 'created'} successfully`);
        setOpenDialog(false);
        setServiceImagePreview(null);
        setMarkerImagePreview(null);
        fetchServices();
      } else {
        alert(response.message || 'Operation failed');
      }
    } catch (err) {
      console.error('Service operation error:', err);
      alert('Operation failed');
    } finally {
      setSubmitting(false);
    }
  };

  // Conditional validation schema based on is_local
  const getValidationSchema = (isLocal) => {
    let schema = {
      name: Yup.string().required('Service name is required'),
      description: Yup.string().required('Description is required'),
      capacity: Yup.number()
        .required('Capacity is required')
        .positive('Capacity must be positive')
        .integer('Capacity must be an integer'),
      base_fare: Yup.number()
        .required('Base Fare Km is required')
        .min(0, 'Base Fare Km cannot be negative'),
      pickup_km: Yup.number()
        .required('Minimum Pickup is required')
        .min(0, 'Minimum Pickup cannot be negative'),
      pickup_fare: Yup.number()
        .required('Pickup fare is required')
        .min(0, 'Pickup fare cannot be negative'),
      minimum_distance: Yup.number()
        .required('Minimum distance is required')
        .min(0, 'Minimum distance cannot be negative'),
      waiting_time_limit: Yup.number()
        .required('Waiting time limit is required')
        .min(0, 'Waiting time limit cannot be negative'),
      per_distance: Yup.number()
        .required('Minimum Fare is required')
        .min(0, 'Minimum Fare cannot be negative'),
      night_fare: Yup.number()
        .required('Night fare is required')
        .min(0, 'Night fare cannot be negative')
        .max(100, 'Night fare cannot exceed 100%'),
      payment_method: Yup.string().required('Payment method is required'),
      status: Yup.string().required('Status is required'),
    };

    // Only require region_id if is_local is true
    if (isLocal) {
      schema.region_id = Yup.string().required('Region is required for local services');
    } else {
      schema.region_id = Yup.string().nullable();
    }

    return Yup.object(schema);
  };

  // Get region name from ID
  const getRegionName = (regionId) => {
    if (!regionId) return 'Global';
    const region = regions.find(r => r.id === regionId);
    return region ? region.name : 'Unknown Region';
  };

  // Filter services by selected region
  const filteredServices = selectedRegion
    ? services.filter(service => service.region_id === selectedRegion)
    : services;

  // Get selected region name for display
  const selectedRegionName = selectedRegion ? getRegionName(selectedRegion) : 'All Regions';

  const columns = [
    {
      field: 'name',
      headerName: 'Service Name',
      width: 200,
      renderCell: (params) => (
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
          <Build color="primary" />
          <Typography variant="body2" fontWeight={600}>
            {params.row.name}
          </Typography>
        </Box>
      ),
    },
    {
      field: 'description',
      headerName: 'Description',
      width: 250,
    },
    {
      field: 'region_id',
      headerName: 'Region',
      width: 150,
      renderCell: (params) => (
        <Typography variant="body2">
          {getRegionName(params.row.region_id)}
        </Typography>
      ),
    },
    {
      field: 'is_local',
      headerName: 'Availability',
      width: 130,
      renderCell: (params) => (
        <Chip
          // icon={params.row.is_local ? <LocationOn /> : <Public />}
          label={params.row.is_local ? getRegionName(params.row.region_id) + ' Local' : getRegionName(params.row.region_id)}
          color={params.row.is_local ? 'primary' : 'success'}
          size="small"
          variant="outlined"
        />
      ),
    },
    {
      field: 'pickup_fare',
      headerName: 'Pickup Fare',
      width: 130,
      renderCell: (params) => (
        <Typography variant="body2">
          ₹{params.row.pickup_fare || 0}
        </Typography>
      ),
    },
    {
      field: 'per_distance',
      headerName: 'Minimum Fare',
      width: 130,
      renderCell: (params) => (
        <Typography variant="body2">
          ₹{params.row.per_distance || 0}
        </Typography>
      ),
    },
    {
      field: 'base_fare',
      headerName: 'Base Fare Km',
      width: 130,
      renderCell: (params) => (
        <Typography variant="body2">
          ₹{params.row.base_fare || 0}/km
        </Typography>
      ),
    },
    {
      field: 'capacity',
      headerName: 'Capacity',
      width: 100,
      renderCell: (params) => (
        <Typography variant="body2">
          {params.row.capacity || 0} passengers
        </Typography>
      ),
    },
    {
      field: 'status',
      headerName: 'Status',
      width: 120,
      renderCell: (params) =>
        params.row.status === 'active' ? (
          <Chip label="Active" color="success" size="small" />
        ) : (
          <Chip label="Inactive" color="default" size="small" />
        ),
    },
    {
      field: 'actions',
      headerName: 'Actions',
      width: 150,
      sortable: false,
      renderCell: (params) => (
        <Box>
          <IconButton size="small" onClick={() => handleEdit(params.row)}>
            <Edit fontSize="small" />
          </IconButton>
          <IconButton size="small" color="error" onClick={() => handleDelete(params.row.id)}>
            <Delete fontSize="small" />
          </IconButton>
        </Box>
      ),
    },
  ];

  return (
    <Box>
      <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 3 }}>
        <Box>
          <Typography variant="h4" fontWeight="bold" gutterBottom>
            Services
          </Typography>
          <Typography variant="body2" color="text.secondary">
            Manage ride services
          </Typography>
        </Box>
        <Button variant="contained" startIcon={<Add />} onClick={handleAdd}>
          Add Service
        </Button>
      </Box>

      {error && (
        <Alert severity="error" sx={{ mb: 3 }}>
          {error}
        </Alert>
      )}

      {/* Region Filter Section */}
      <Paper sx={{ p: 2, mb: 3, display: 'flex', alignItems: 'center', gap: 2, flexWrap: 'wrap' }}>
        <FilterList color="action" />
        <FormControl sx={{ minWidth: 250 }}>
          <InputLabel>Filter by Region</InputLabel>
          <Select
            value={selectedRegion}
            onChange={(e) => setSelectedRegion(e.target.value)}
            label="Filter by Region"
          >
            <MenuItem value="">All Regions</MenuItem>
            {regions.map((region) => (
              <MenuItem key={region.id} value={region.id}>
                {region.name}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
        {selectedRegion && (
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
            <Chip
              label={`${selectedRegionName}`}
              color="primary"
              size="medium"
              onDelete={() => setSelectedRegion('')}
            />
            <Typography variant="body2" color="text.secondary">
              ({filteredServices.length} service{filteredServices.length !== 1 ? 's' : ''})
            </Typography>
          </Box>
        )}
        {!selectedRegion && (
          <Typography variant="body2" color="text.secondary">
            Showing all services ({filteredServices.length} total)
          </Typography>
        )}
      </Paper>

      <Card>
        <CardContent>
          <DataGrid
            rows={filteredServices}
            columns={columns}
            pageSize={10}
            rowsPerPageOptions={[10, 25, 50]}
            disableSelectionOnClick
            autoHeight
            loading={loading}
            sx={{
              '& .MuiDataGrid-cell:focus': {
                outline: 'none',
              },
            }}
          />
        </CardContent>
      </Card>

      {/* Add/Edit Service Dialog */}
      <Dialog open={openDialog} onClose={() => setOpenDialog(false)} maxWidth="md" fullWidth>
        <DialogTitle>{editMode ? 'Edit' : 'Add'} Service</DialogTitle>
        <Formik
          initialValues={{
            name: selectedService?.name || '',
            description: selectedService?.description || '',
            region_id: selectedService?.region_id || '',
            capacity: selectedService?.capacity || '',
            base_fare: selectedService?.base_fare || '',
            pickup_km: selectedService?.pickup_km || '',
            pickup_fare: selectedService?.pickup_fare || '',
            minimum_distance: selectedService?.minimum_distance || '',
            waiting_time_limit: selectedService?.waiting_time_limit || '',
            per_distance: selectedService?.per_distance || '',
            night_fare: selectedService?.night_fare || '',
            payment_method: selectedService?.payment_method || 'cash',
            status: selectedService?.status || 'active',
            isActive: selectedService?.isActive ?? true,
            toll_applicable: selectedService?.toll_applicable ?? true,
            is_local: selectedService?.is_local ?? false,
          }}
          validationSchema={getValidationSchema}
          onSubmit={handleSubmit}
        >
          {({ values, errors, touched, handleChange, handleBlur, isSubmitting, setFieldValue }) => (
            <Form>
              <DialogContent>
                <Grid container spacing={3}>
                  <Grid item xs={12} sm={6}>
                    <TextField
                      fullWidth
                      name="name"
                      label="Service Name"
                      value={values.name}
                      onChange={handleChange}
                      onBlur={handleBlur}
                      error={touched.name && Boolean(errors.name)}
                      helperText={touched.name && errors.name}
                      placeholder="e.g., Regular Ride"
                    />
                  </Grid>

                  <Grid item xs={12} sm={6}>
                    <FormControl fullWidth error={touched.region_id && Boolean(errors.region_id)}>
                      <InputLabel>Region</InputLabel>
                      <Select
                        name="region_id"
                        value={values.region_id}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        label="Region"                        
                      >
                        {regions.map((region) => (
                          <MenuItem key={region.id} value={region.id}>
                            {region.name}
                          </MenuItem>
                        ))}
                      </Select>
                      {touched.region_id && errors.region_id && (
                        <Typography variant="caption" color="error" sx={{ mt: 0.5, ml: 1.5 }}>
                          {errors.region_id}
                        </Typography>
                      )}
                      {values.is_local && (
                        <Typography variant="caption" color="text.secondary" sx={{ mt: 0.5, ml: 1.5 }}>
                          Select a region for this local service
                        </Typography>
                      )}
                    </FormControl>
                  </Grid>

                  <Grid item xs={12}>
                    <TextField
                      fullWidth
                      name="description"
                      label="Description"
                      value={values.description}
                      onChange={handleChange}
                      onBlur={handleBlur}
                      error={touched.description && Boolean(errors.description)}
                      helperText={touched.description && errors.description}
                      multiline
                      rows={3}
                      placeholder="Describe the service..."
                    />
                  </Grid>

                  <Grid item xs={12} sm={6}>
                    <TextField
                      fullWidth
                      name="capacity"
                      label="Capacity"
                      type="number"
                      value={values.capacity}
                      onChange={handleChange}
                      onBlur={handleBlur}
                      error={touched.capacity && Boolean(errors.capacity)}
                      helperText={touched.capacity && errors.capacity}
                      placeholder="e.g., 4"
                      InputProps={{
                        endAdornment: <InputAdornment position="end">passengers</InputAdornment>,
                      }}
                    />
                  </Grid>

                  <Grid item xs={12} sm={6}>
                    <TextField
                      fullWidth
                      name="per_distance"
                      label="Minimum Fare"
                      type="number"
                      value={values.per_distance}
                      onChange={handleChange}
                      onBlur={handleBlur}
                      error={touched.per_distance && Boolean(errors.per_distance)}
                      helperText={touched.per_distance && errors.per_distance || "Minimum total ride fare amount"}
                      placeholder="e.g., 50"
                      InputProps={{
                        startAdornment: <InputAdornment position="start">₹</InputAdornment>,
                      }}
                    />
                  </Grid>

                  <Grid item xs={12} sm={6}>
                    <TextField
                      fullWidth
                      name="base_fare"
                      label="Base Fare Km"
                      type="number"
                      value={values.base_fare}
                      onChange={handleChange}
                      onBlur={handleBlur}
                      error={touched.base_fare && Boolean(errors.base_fare)}
                      helperText={touched.base_fare && errors.base_fare || "Per-km rate for extra distance beyond minimum distance"}
                      placeholder="e.g., 14"
                      InputProps={{
                        startAdornment: <InputAdornment position="start">₹</InputAdornment>,
                        endAdornment: <InputAdornment position="end">/km</InputAdornment>,
                      }}
                    />
                  </Grid>

                  <Grid item xs={12} sm={6}>
                    <TextField
                      fullWidth
                      name="pickup_km"
                      label="Minimum Pickup"
                      type="number"
                      value={values.pickup_km}
                      onChange={handleChange}
                      onBlur={handleBlur}
                      error={touched.pickup_km && Boolean(errors.pickup_km)}
                      helperText={touched.pickup_km && errors.pickup_km}
                      placeholder="e.g., 2"
                      InputProps={{
                        endAdornment: <InputAdornment position="end">km</InputAdornment>,
                      }}
                    />
                  </Grid>

                  <Grid item xs={12} sm={6}>
                    <TextField
                      fullWidth
                      name="pickup_fare"
                      label="Pickup Fare"
                      type="number"
                      value={values.pickup_fare}
                      onChange={handleChange}
                      onBlur={handleBlur}
                      error={touched.pickup_fare && Boolean(errors.pickup_fare)}
                      helperText={touched.pickup_fare && errors.pickup_fare}
                      placeholder="e.g., 30"
                      InputProps={{
                        startAdornment: <InputAdornment position="start">₹</InputAdornment>,
                        endAdornment: <InputAdornment position="end">/km</InputAdornment>,
                      }}
                    />
                  </Grid>

                  <Grid item xs={12} sm={6}>
                    <TextField
                      fullWidth
                      name="minimum_distance"
                      label="Minimum Distance"
                      type="number"
                      value={values.minimum_distance}
                      onChange={handleChange}
                      onBlur={handleBlur}
                      error={touched.minimum_distance && Boolean(errors.minimum_distance)}
                      helperText={touched.minimum_distance && errors.minimum_distance}
                      placeholder="e.g., 1"
                      InputProps={{
                        endAdornment: <InputAdornment position="end">km</InputAdornment>,
                      }}
                    />
                  </Grid>

                  <Grid item xs={12} sm={6}>
                    <TextField
                      fullWidth
                      name="waiting_time_limit"
                      label="Waiting Time Limits"
                      type="number"
                      value={values.waiting_time_limit}
                      onChange={handleChange}
                      onBlur={handleBlur}
                      error={touched.waiting_time_limit && Boolean(errors.waiting_time_limit)}
                      helperText={touched.waiting_time_limit && errors.waiting_time_limit}
                      placeholder="e.g., 5"
                      InputProps={{
                        endAdornment: <InputAdornment position="end">minutes</InputAdornment>,
                      }}
                    />
                  </Grid>

                  <Grid item xs={12} sm={6}>
                    <TextField
                      fullWidth
                      name="night_fare"
                      label="Night Fare"
                      type="number"
                      value={values.night_fare}
                      onChange={handleChange}
                      onBlur={handleBlur}
                      error={touched.night_fare && Boolean(errors.night_fare)}
                      helperText={touched.night_fare && errors.night_fare}
                      placeholder="e.g., 20"
                      InputProps={{
                        endAdornment: <InputAdornment position="end">%</InputAdornment>,
                      }}
                    />
                  </Grid>

                  <Grid item xs={12} sm={6}>
                    <FormControl fullWidth error={touched.payment_method && Boolean(errors.payment_method)}>
                      <InputLabel>Payment Method</InputLabel>
                      <Select
                        name="payment_method"
                        value={values.payment_method}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        label="Payment Method"
                      >
                        <MenuItem value="cash">Cash</MenuItem>
                        <MenuItem value="wallet">Wallet</MenuItem>
                        <MenuItem value="both">Both</MenuItem>
                      </Select>
                      {touched.payment_method && errors.payment_method && (
                        <Typography variant="caption" color="error" sx={{ mt: 0.5, ml: 1.5 }}>
                          {errors.payment_method}
                        </Typography>
                      )}
                    </FormControl>
                  </Grid>

                  <Grid item xs={12} sm={6}>
                    <FormControl fullWidth error={touched.status && Boolean(errors.status)}>
                      <InputLabel>Status</InputLabel>
                      <Select
                        name="status"
                        value={values.status}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        label="Status"
                      >
                        <MenuItem value="active">Active</MenuItem>
                        <MenuItem value="inactive">Inactive</MenuItem>
                      </Select>
                      {touched.status && errors.status && (
                        <Typography variant="caption" color="error" sx={{ mt: 0.5, ml: 1.5 }}>
                          {errors.status}
                        </Typography>
                      )}
                    </FormControl>
                  </Grid>

                  <Grid item xs={12}>
                    <FormControlLabel
                      control={
                        <Checkbox
                          name="is_local"
                          checked={values.is_local}
                          onChange={(e) => {
                            const isLocal = e.target.checked;
                            setFieldValue('is_local', isLocal);                            
                          }}
                        />
                      }
                      label={
                        <Box>
                          <Typography variant="body1">Local Service</Typography>
                          <Typography variant="caption" color="text.secondary">
                            {values.is_local 
                              ? 'Service will only be available in the selected region' 
                              : 'Service will be available globally across all regions'}
                          </Typography>
                        </Box>
                      }
                    />
                  </Grid>

                  <Grid item xs={12}>
                    <FormControlLabel
                      control={
                        <Checkbox
                          name="toll_applicable"
                          checked={values.toll_applicable}
                          onChange={(e) => setFieldValue('toll_applicable', e.target.checked)}
                        />
                      }
                      label="Show Toll Charges Notice"
                    />
                    <Typography variant="caption" display="block" color="text.secondary" sx={{ ml: 4 }}>
                      When enabled, passengers booking this service will see a toll-charges disclaimer.
                      Disable for services that cannot use toll roads (e.g., Auto).
                    </Typography>
                  </Grid>

                  <Grid item xs={12} sm={6}>
                    <Button
                      variant="outlined"
                      component="label"
                      fullWidth
                      startIcon={<CloudUpload />}
                      sx={{ height: '56px' }}
                    >
                      Upload Service Image
                      <input
                        type="file"
                        hidden
                        accept="image/*"
                        onChange={(e) => {
                          const file = e.target.files[0];
                          if (file) {
                            setFieldValue('service_image', file);
                            setServiceImagePreview(URL.createObjectURL(file));
                          }
                        }}
                      />
                    </Button>
                    {serviceImagePreview && (
                      <Box sx={{ mt: 2, textAlign: 'center', p: 2, bgcolor: '#f5f5f5', borderRadius: 2 }}>
                        <Box
                          component="img"
                          src={serviceImagePreview}
                          alt="Service Preview"
                          sx={{
                            maxWidth: '100%',
                            maxHeight: 150,
                            borderRadius: 1,
                            border: '2px solid #e0e0e0',
                          }}
                          onError={(e) => {
                            console.error('Service image failed to load:', serviceImagePreview);
                            e.target.src = 'data:image/svg+xml,%3Csvg xmlns="http://www.w3.org/2000/svg" width="100" height="100"%3E%3Crect fill="%23f0f0f0" width="100" height="100"/%3E%3Ctext x="50%25" y="50%25" text-anchor="middle" dy=".3em" fill="%23999"%3ENo Image%3C/text%3E%3C/svg%3E';
                          }}
                        />
                        <Typography variant="caption" display="block" sx={{ mt: 1, color: 'text.secondary' }}>
                          {serviceImagePreview.includes('blob:') ? 'New image selected' : 'Current image'}
                        </Typography>
                      </Box>
                    )}
                  </Grid>

                  <Grid item xs={12} sm={6}>
                    <Button
                      variant="outlined"
                      component="label"
                      fullWidth
                      startIcon={<CloudUpload />}
                      sx={{ height: '56px' }}
                    >
                      Upload Marker Image (Top View Vehicle – 48×48 px)
                      <input
                        type="file"
                        hidden
                        accept="image/png,image/jpeg"
                        onChange={(e) => {
                          const file = e.target.files[0];
                          if (file) {
                            const img = new Image();
                            img.onload = () => {
                              if (img.width === 48 && img.height === 48) {
                                setFieldValue('marker_image', file);
                                setMarkerImagePreview(URL.createObjectURL(file));
                              } else {
                                alert(`Invalid marker image size: ${img.width}×${img.height}px. Must be exactly 48×48 pixels.`);
                                e.target.value = '';
                              }
                            };
                            img.src = URL.createObjectURL(file);
                          }
                        }}
                      />
                    </Button>
                    {markerImagePreview && (
                      <Box sx={{ mt: 2, textAlign: 'center', p: 2, bgcolor: '#f5f5f5', borderRadius: 2 }}>
                        <Box
                          component="img"
                          src={markerImagePreview}
                          alt="Marker Preview"
                          sx={{
                            maxWidth: '100%',
                            maxHeight: 150,
                            borderRadius: 1,
                            border: '2px solid #e0e0e0',
                          }}
                          onError={(e) => {
                            console.error('Marker image failed to load:', markerImagePreview);
                            e.target.src = 'data:image/svg+xml,%3Csvg xmlns="http://www.w3.org/2000/svg" width="100" height="100"%3E%3Crect fill="%23f0f0f0" width="100" height="100"/%3E%3Ctext x="50%25" y="50%25" text-anchor="middle" dy=".3em" fill="%23999"%3ENo Image%3C/text%3E%3C/svg%3E';
                          }}
                        />
                        <Typography variant="caption" display="block" sx={{ mt: 1, color: 'text.secondary' }}>
                          {markerImagePreview.includes('blob:') ? 'New image selected' : 'Current image'}
                        </Typography>
                      </Box>
                    )}
                  </Grid>
                </Grid>
              </DialogContent>
              <DialogActions>
                <Button onClick={() => setOpenDialog(false)}>Cancel</Button>
                <Button
                  type="submit"
                  variant="contained"
                  disabled={isSubmitting}
                  sx={{
                    bgcolor: '#FFC107',
                    color: '#000',
                    '&:hover': {
                      bgcolor: '#FFD54F',
                    },
                  }}
                >
                  {editMode ? 'Update' : 'Create'}
                </Button>
              </DialogActions>
            </Form>
          )}
        </Formik>
      </Dialog>
    </Box>
  );
};

export default ServicesPage;